import CommonPickerCpt from '@/components/data-picker/CommonPickerCpt';
import PopupDatePickerCpt from '@/components/date-time/PopupDatePickerCpt';
import { rqtGetProduct, rqtPostProductOpenDateListByQuery, rqtPostProductLatestNetValue } from '@/services/wms/product';
import { rqtPostCustomerProductTradeShareList } from '@/services/wms/trade';
import { rqtPostRedemptionApplicationList, rqtPostRedemptionApplication, rqtPutRedemptionApplication, rqtPutRedemptionApplicationCancel } from "@/services/wms/redemption";
import cptCmn from '@/mixin/cpt-cmn';
import { getUnrelatedAttachments, delUnrelatedAttachments } from '@/utils/public/file';
import { showConfirmDialog, showNotify } from 'vant';
export default {
  name: 'RedemptionDetailCpt',
  mixins: [cptCmn],
  components: {
    CommonPickerCpt,
    PopupDatePickerCpt
  },
  data() {
    return {
      customerId: null,
      productId: null,
      redemptionId: null,
      productName: null,
      openDate: null,
      openDateRequest: rqtPostProductOpenDateListByQuery,
      openDateParams: null,
      openDateFieldNames: {
        text: 'openDate',
        value: 'openDate'
      },
      netValueForm: {
        netValue: null,
        publicDate: null,
        applicationDate: null,
        applicationRedemptionShare: null,
        applicationRedemptionAmount: null,
        redemptionStatus: null,
        actualNetValue: null,
        actualRedemptionShare: null
      },
      tradeRedemptions: [],
      //本次赎回明细，页面上不展示，传给后台接口需要
      redemptionSharePattern: /^\d+(\.\d{0,2})?$/,
      codeResItems: [{
        title: '赎回状态',
        dataIndex: 'redemptionStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'redemptionStatus'
      }],
      submitLoading: false,
      cancelLoading: false,
      attachmentType: '06',
      attachmentIds: [],
      lastCustomerId: null,
      lastProductId: null,
      lastRedemptionId: null
    };
  },
  computed: {
    readonly() {
      return this.netValueForm.redemptionStatus && this.netValueForm.redemptionStatus != "01";
    },
    showCancel() {
      return this.netValueForm.redemptionStatus == "01";
    },
    leftShareBeforeOpenDate() {
      let total = 0;
      for (let item of this.tradeRedemptions) {
        total = total + item.actualSubscriptionShare - item.redemptionShare;
      }
      return Math.round(total * 100) / 100;
    },
    leftShareCanRedemption() {
      let total = 0;
      for (let item of this.tradeRedemptions) {
        if (item.redemptionFlag == 'Y') {
          total = total + item.actualSubscriptionShare - item.redemptionShare;
        }
      }
      return Math.round(total * 100) / 100;
    },
    redemptionProgressType() {
      let leftShare = this.leftShareBeforeOpenDate;
      leftShare = Math.round((this.leftShareBeforeOpenDate - this.netValueForm.applicationRedemptionShare) * 100) / 100;
      if (leftShare <= 0) {
        return "03"; //全部赎回
      } else {
        return "02"; //部分赎回
      }
    },

    applicationRedemptionAmount() {
      if (!this.netValueForm.applicationRedemptionShare || !this.netValueForm.netValue) return;
      return Math.round(this.netValueForm.applicationRedemptionShare * this.netValueForm.netValue * 100) / 100;
    }
  },
  async activated() {
    if (!this.$route.params.redemptionId || this.$route.params.redemptionId == '') {
      this.redemptionId = null;
    } else {
      this.redemptionId = Number(this.$route.params.redemptionId);
    }
    if (!this.$route.params.productId || this.$route.params.productId == '') {
      this.productId = null;
    } else {
      this.productId = Number(this.$route.params.productId);
    }
    if (!this.$route.params.customerId || this.$route.params.customerId == '') {
      this.customerId = null;
    } else {
      this.customerId = Number(this.$route.params.customerId);
    }
    this.init();
  },
  methods: {
    async init(isPullRefreshing) {
      if (isPullRefreshing || this.redemptionId != this.lastRedemptionId || this.customerId != this.lastCustomerId || this.productId != this.lastProductId) {
        this.lastCustomerId = this.customerId;
        this.lastProductId = this.productId;
        this.lastRedemptionId = this.redemptionId;
      } else {
        return;
      }
      rqtGetProduct(this.productId).then(res => {
        res = res.data.data;
        this.productName = res.productName;
      });
      if (!this.redemptionId) {
        this.openDate = null;
        for (const key in this.netValueForm) {
          this.netValueForm[key] = null;
        }
        this.tradeRedemptions = [];
      } else {
        this.initResCodeType(this.codeResItems);
        try {
          let params = {
            id: this.redemptionId,
            curPage: 1,
            length: 10
          };
          let redemptionRes = await rqtPostRedemptionApplicationList(params);
          redemptionRes = redemptionRes.data.data[0];
          this.openDate = redemptionRes.productOpenDate;
          this.netValueForm.netValue = redemptionRes.applicationNetValue;
          this.netValueForm.netValue = 111;
          this.netValueForm.publicDate = redemptionRes.applicationNetValuePubDate;
          this.netValueForm.applicationDate = redemptionRes.applicationDate;
          this.netValueForm.applicationRedemptionShare = redemptionRes.applicationRedemptionShare;
          this.netValueForm.redemptionStatus = redemptionRes.redemptionStatus;
          this.netValueForm.actualNetValue = redemptionRes.actualNetValue;
          this.netValueForm.actualRedemptionShare = redemptionRes.actualRedemptionShare;
          this.loadTradeRedemptions();
        } catch (error) {
          console.error(error);
        }
      }
    },
    redemptionShareValidator(val) {
      return val > 0 && val <= this.leftShareCanRedemption;
    },
    onSubmit() {
      let leftShare = this.leftShareBeforeOpenDate - this.netValueForm.applicationRedemptionShare;
      let leftAmount = Math.round(leftShare * this.netValueForm.netValue * 100) / 100;
      if (leftShare > 0 && leftAmount <= 1050000) {
        showConfirmDialog({
          title: '提醒',
          allowHtml: true,
          message: "<span>剩余份额" + leftShare + "份，金额" + leftAmount + "元，</span><font style='color: red'>" + "特别提醒：赎回日可能因净值大幅波动、导致剩余金额未满100万元而造成客户剩余份额全部赎回。如已知晓相关风险仍需按此份额赎回，请按确认。否则，请取消并减少份额后重新提交。"
        }).then(() => {
          this.save();
        }).catch(() => {
          return;
        });
      } else {
        this.save();
      }
    },
    save() {
      this.submitLoading = true;
      const redemption = {
        id: this.redemptionId,
        customerId: this.customerId,
        productId: this.productId,
        productOpenDate: this.openDate,
        redemptionType: '03',
        applicationDate: this.netValueForm.applicationDate,
        applicationRedemptionShare: this.netValueForm.applicationRedemptionShare,
        applicationRedemptionAmount: this.applicationRedemptionAmount,
        applicationNetValue: this.netValueForm.netValue,
        applicationNetValuePubDate: this.netValueForm.publicDate,
        redemptionStatus: "02",
        redemptionProgressType: this.redemptionProgressType
      };
      const tradeRedemptions = this.tradeRedemptions.map(function (item) {
        return {
          id: item.id,
          redemptionId: item.redemptionId,
          tradeId: item.tradeId,
          applicationRedemptionShare: item.applicationRedemptionShare
        };
      });
      const workFlowNode = {
        status: '2'
      };
      const params = {
        redemption: redemption,
        tradeRedemptions: tradeRedemptions,
        workFlowNode: workFlowNode
      };
      if (this.redemptionId) {
        rqtPutRedemptionApplication(this.redemptionId, params).then(() => {
          this.onSaveSuccess();
        }).catch(() => {
          this.onSaveFailure();
        });
      } else {
        let localAttachments = getUnrelatedAttachments(this.attachmentType);
        if (localAttachments.length > 0) {
          params.attachmentIds = localAttachments.map(e => e.id);
        }
        rqtPostRedemptionApplication(params).then(() => {
          delUnrelatedAttachments();
          this.onSaveSuccess();
        }).catch(() => {
          this.onSaveFailure();
        });
      }
    },
    onSaveSuccess() {
      this.submitLoading = false;
      this.lastCustomerId = null;
      this.lastProductId = null;
      this.lastRedemptionId = null;
      showNotify({
        type: "success",
        message: "赎回申请成功"
      });
      this.$router.go(-1);
    },
    onSaveFailure() {
      this.submitLoading = false;
    },
    cancel() {
      let that = this;
      showConfirmDialog({
        title: '提醒',
        message: "是否撤销该笔赎回？"
      }).then(() => {
        this.cancelLoading = true;
        let params = [that.redemptionId];
        rqtPutRedemptionApplicationCancel(params).then(() => {
          showNotify({
            type: "success",
            message: "赎回申请已撤销"
          });
          this.cancelLoading = false;
          this.lastCustomerId = null;
          this.lastProductId = null;
          this.lastRedemptionId = null;
          this.$router.go(-1);
        });
      }).catch(() => {
        this.cancelLoading = false;
        return;
      });
    },
    onOpenDateClick() {
      if (!this.readonly) {
        this.openDateParams = {
          productId: this.productId
        };
        this.$nextTick(() => {
          this.$refs.commonPickerCpt.showView();
        });
      }
    },
    async onOpenDateChange(selectedValues) {
      this.openDate = selectedValues[0];
      try {
        const params = {
          productId: this.productId,
          publicDate: this.openDate
        };
        let res = await rqtPostProductLatestNetValue(params);
        res = res.data.data;
        this.netValueForm.netValue = res.netValue;
        this.netValueForm.publicDate = res.publicDate;

        //如果是修改就不用再加载了，因为mount的时候加载过了
        if (!this.redemptionId) {
          this.loadTradeRedemptions();
        }
      } catch (error) {
        console.error(error);
      }
    },
    onPopupDatePickerSelectClick() {
      if (!this.readonly) {
        this.$refs.popupDatePickerCpt.showView();
      }
    },
    onDatePickerSelectedChange(date) {
      this.netValueForm.applicationDate = date;
    },
    onApplicationShareChange() {
      if (!this.netValueForm.applicationRedemptionShare || this.netValueForm.applicationRedemptionShare <= 0) {
        return;
      }
      let applicationRedemptionShare = this.netValueForm.applicationRedemptionShare;
      for (let item of this.tradeRedemptions) {
        let left = item.actualSubscriptionShare - item.redemptionShare;
        if (left > 0 && applicationRedemptionShare > 0 && item.redemptionFlag == 'Y') {
          if (left >= applicationRedemptionShare) {
            item.applicationRedemptionShare = Math.round(applicationRedemptionShare * 100) / 100;
            break;
          } else {
            item.applicationRedemptionShare = Math.round(left * 100) / 100;
            applicationRedemptionShare = applicationRedemptionShare - item.applicationRedemptionShare;
          }
        }
      }
    },
    async loadTradeRedemptions() {
      const params = {
        redemptionId: this.redemptionId,
        customerId: this.customerId,
        productId: this.productId,
        calcDate: this.openDate
      };
      const res = await rqtPostCustomerProductTradeShareList(params);
      this.tradeRedemptions = res.data.data;
    }
  }
};